import { ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Line, LineChart, ResponsiveContainer, LabelList } from 'recharts';

type chartDataInvoiceTypes = Array<{
  month: string;
  jobs: number;
  quotes: number;
  jobsPreviousYear: number;
  quotesPreviousYear: number;
}>

const MainQuoteWorkChart = (props: {onChartData: chartDataInvoiceTypes}) => (
  <ResponsiveContainer width="100%" height={280}>
    <ComposedChart style={{maxWidth: "100%"}} width={1000} height={400} data={props.onChartData}>

      <defs>
        <linearGradient id="colorJob" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#e9530d" stopOpacity={0.8}/>
          <stop offset="95%" stopColor="#b13406" stopOpacity={0.8}/>
        </linearGradient>
        <linearGradient id="colorJobPrevious" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#FCC472" stopOpacity={0.8}/>
          <stop offset="95%" stopColor="#FCC472" stopOpacity={0.8}/>
        </linearGradient>
      </defs>

      <CartesianGrid strokeDasharray="3 3" />

      <XAxis tick={{ fontSize: "9pt", fill: "rgb(30, 42, 78)" }} dataKey="month"  tickMargin={10}/>
      <YAxis tick={{ fontSize: "9pt", fill: "rgb(30, 42, 78)" }} tickMargin={10}/>

      <Tooltip
        contentStyle={{
          backgroundColor: 'rgba(255, 255, 255, 0.7)', 
          borderColor: 'rgba(150, 150, 150, 0.8)',     
          color: 'rgb(138 137 179)'                              
        }}
        itemStyle={{ color: 'black' }}
        labelStyle={{ color: 'black' }}
      />

      <Legend
        content={({ payload }) => (
          <ul style={{
            listStyle: 'none',
            display: 'flex',
            margin: '1em 0 0 0',
            padding: 0,
            justifyContent: 'center',
          }}>
            {
              payload?.map((entry, index) => (
                <li key={`item-${index}`} style={{ marginRight: 10, display: 'flex', alignItems: 'center' }}>
                  <svg height="14" width="14">
                    <rect width="14" height="14" style={{ fill: entry.color }} />
                  </svg>
                  <span style={{ marginLeft: 5, fontSize: '9pt', color: 'black' }}>{entry.value}</span>
                </li>
              ))
            }
          </ul>
        )}
      />

      <Bar dataKey="jobsPreviousYear" fill="url(#colorJobPrevious)" name="Jobs Previous Year">
        <LabelList dataKey="jobsPreviousYear" position="top" style={{ fill: 'rgb(138 137 179)', fontSize: "9pt", fontWeight: "bold" }} />
      </Bar>
      <Bar dataKey="jobs" fill="url(#colorJob)" name="Jobs This Year">
        <LabelList dataKey="jobs" position="top" style={{ fill: 'rgb(138 137 179)', fontSize: "9pt", fontWeight: "bold" }} />
      </Bar>
    </ComposedChart>
  </ResponsiveContainer>
);

export default MainQuoteWorkChart;
